import { createContext } from 'react'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'

type PendingLoginModalHandlers = Partial<Record<App.UiAccountModalMode, () => Promise<AccountAccessModalResult>>>

const PendingLoginModalContext = createContext<PendingLoginModalHandlers>({})

export default PendingLoginModalContext
